import {
  AccountCircle as AccountCircleIcon,
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNotifications } from "../../hooks/useNotifications";
import NotificationPanel from "../notifications/NotificationPanel";
import { RoleSwitcher } from "../RoleSwitcher";
import { LanguageSwitcher } from "../LanguageSwitcher";
import { useAuth } from "../../contexts/AuthContext";

interface HeaderProps {
  sidebarOpen: boolean;
  onSidebarToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ sidebarOpen: _sidebarOpen, onSidebarToggle }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const {
    unreadCount,
    panelOpen,
    toggleNotificationPanel,
    setNotificationPanelOpen,
  } = useNotifications();

  const handleLogout = async () => {
    await logout();
    navigate("/auth/login");
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="toggle sidebar"
            onClick={onSidebarToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            {t('appTitle')}
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {/* Переключатель ролей */}
            <RoleSwitcher />
            
            {/* Переключатель языка */}
            <LanguageSwitcher />
            
            <Tooltip title={t('notificationUI.label')}>
              <IconButton color="inherit" onClick={toggleNotificationPanel}>
                <Badge badgeContent={unreadCount} color="error" max={99}>
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            <Tooltip title={t('navigation.settingsLabel')}>
              <IconButton color="inherit" onClick={() => navigate('/settings')}>
                <SettingsIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title={t('profile')}>
              <IconButton color="inherit" sx={{ ml: 1 }} onClick={() => navigate('/settings/profile')}>
                <Avatar sx={{ width: 32, height: 32 }}>
                  <AccountCircleIcon />
                </Avatar>
              </IconButton>
            </Tooltip>

            <Tooltip title={t('logout') || 'Выйти'}>
              <IconButton color="inherit" onClick={handleLogout}>
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Панель уведомлений */}
      <NotificationPanel
        open={panelOpen}
        onClose={() => setNotificationPanelOpen(false)}
      />
    </>
  );
};

export default Header;
